
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form7DataInfoType } from '@/types/Information/Form7';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form7Layout extends Vue {

    @Prop({required:true})
    result!: form7DataInfoType;
}

